var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "del",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            modal: true,
            width: 560,
            height: 204,
            confirmButtonText: _vm.sureout,
            "append-to-body": "",
          },
          on: {
            confirm: _vm.handleConfirm,
            "after-close": _vm.handleAfterClose,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [_vm._v("确定要退出腾达云管理系统吗？")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }